module.exports = __webpack_public_path__ + "static/media/cervical-ripening-balloon-steps-of-use-poster.17863cf0.jpg";